/* eslint-disable */
import React, {useState, useEffect} from "react";
import styles from "./AddSurvey.module.css";
import {FormControlLabel, IconButton, InputAdornment, Modal, Radio, RadioGroup, TextField, withStyles} from "@material-ui/core";
import PuiButton from "../elements/PuiButton";
import PuiTypography from "../elements/PuiTypography";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddIcon from "@material-ui/icons/Add";
import {AddSurveyIF} from "../../models/survey";
import {useDispatch} from "react-redux";
import {AddSurvey} from "../../store/actions/SurveyActions";
import PuiMessage from "../widgets/PuiMessage";
import {CountWord} from "../../utils/ObjectUtils";

const RedRadio = withStyles({
    root: {
        "&$checked": {
            color: "var(--red)"
       }
   },
    checked: {}
})((props) => <Radio color="default" {...props}/>);

interface AddSurveyProps {
    setIsSaved: (isSaved: boolean) => void;
}

function AddSurveyModal({setIsSaved}: AddSurveyProps) {
    const dispatch = useDispatch();

    const [newSurvey, ChangeNewSurvey] = useState<AddSurveyIF>({
        title: "",
        multipleAnswer: true,
        questionList:[
            {content: "",
                answerType: 0,
                skipFlag: false,
                displayMillis: 15000,
                choiceList: [{content: ""},{content: ""}]
           }]
   });

    // モーダル画面表示制御
    const [isOpenAddSurveyModal, ShowAddSurveyModal] = useState(false);
    const handlePropagation = (event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
   };

    const OpenAddSurveyModal = () =>{
        ShowAddSurveyModal(true);

   };

    const CloseAddSurveyModal = () =>{
        console.log("CloseAddSurveyModal start");
        ShowAddSurveyModal(false);
        CheckInputSurveyName(false);
        ChangeDisplayMillisCustomFlagList([false, false, false, false, false]);
        ErrorInputLimit([false, false, false, false, false]);
        ChangeNewSurvey({
            title: "",
            multipleAnswer: true,
            questionList:[
                {content: "",
                    answerType: 0,
                    skipFlag: false,
                    displayMillis: 15000,
                    choiceList: [{content: ""},{content: ""}]
               }]
       });
   };

    // アンケート名入力
    const [isErrorInputSurveyName,CheckInputSurveyName] = useState(false);
    const InputSurveyName= (event: any) => {
        console.log("InputSurveyName start");
        if (CountWord(event.target.value) > 30) {
            CheckInputSurveyName(true);
       }
        else{
            CheckInputSurveyName(false);
            newSurvey.title = event.target.value;
       }
   };

    // 表示回数選択
    const SelectDisplayFlag= (event: any) => {
        console.log("SelectDisplayFlag start");
        if(event.target.value === "1"){
            newSurvey.multipleAnswer = true;
       }else if(event.target.value === "0"){
            newSurvey.multipleAnswer = false;
       }else{
            console.log("SelectDisplayFlag else");
       }
   };

    // 設問入力
    const InputQuestion= (index: number, event: any) => {
        console.log("InputQuestion start");
        const temp: AddSurveyIF = {...newSurvey};
        temp.questionList[index].content = event.target.value;
        ChangeNewSurvey(temp);
   };

    // 回答方式入力
    const SelectAnswerFormat= (index: number, event: any) => {
        console.log("SelectAnswerFormat start");
        if(event.target.value === "0"){
            newSurvey.questionList[index].answerType = 0;
       }else if(event.target.value === "1"){
            newSurvey.questionList[index].answerType = 1;
       }
   };

    // スキップフラグ選択
    const SelectSkipFlag = (index: number, event: any) => {
        console.log("SelectSkipFlag start");
        if(event.target.value === "true"){
            newSurvey.questionList[index].skipFlag = true;
       }else{
            newSurvey.questionList[index].skipFlag = false;
       }
   };

    // 選択肢入力
    const InputChoice= (index: number, contentIndex: number, event: any) => {
        console.log("InputChoice start");
        const temp: AddSurveyIF = {...newSurvey};
        temp.questionList[index].choiceList[contentIndex].content = event.target.value;
        ChangeNewSurvey(temp);

   };

    // 選択肢追加
    const AddChoice= (index: number) => {
        console.log("InputAnswer start");
        const temp = {...newSurvey};
        temp.questionList[index].choiceList.push({content: ""});
        ChangeNewSurvey(temp);
   };

    const [displayMillisCustomFlagList, ChangeDisplayMillisCustomFlagList] = useState([false, false, false, false, false]);

    // 制限時間入力
    const SelectAnswerLimit= (index: number, num: number) => {
        console.log("SelectAnswerLimit start");
        if(num !== 1){
            console.log("false");
            const temp = [...displayMillisCustomFlagList];
            temp[index] = false;
            ChangeDisplayMillisCustomFlagList(temp);
            newSurvey.questionList[index].displayMillis = num;

            const tempError = [...isErrorInputLimit];
            tempError[index] = false;
            ErrorInputLimit(tempError);
       }else{
            console.log("true");
            const temp = [...displayMillisCustomFlagList];
            temp[index] = true;
            ChangeDisplayMillisCustomFlagList(temp);
            newSurvey.questionList[index].displayMillis = 0;

            const tempError = [...isErrorInputLimit];
            tempError[index] = true;
            ErrorInputLimit(tempError);
       }
   };

    const [isErrorInputLimit, ErrorInputLimit] = useState([false, false, false, false, false]);
    const InputDisplayLimit = (index: number, num: number) => {
        console.log("InputDisplayLimit start");
        if(num > 0 && num <= 600000){
            const temp = [...isErrorInputLimit];
            temp[index] = false;
            ErrorInputLimit(temp);
            newSurvey.questionList[index].displayMillis = num;
       }else{
            const temp = [...isErrorInputLimit];
            temp[index] = true;
            ErrorInputLimit(temp);
       }
   };
    useEffect(() => {
        console.log("displayMillisCustomFlagList", displayMillisCustomFlagList);
        console.log("isErrorInputLimit", isErrorInputLimit);
   },[isErrorInputLimit, displayMillisCustomFlagList]);

    // 設問追加
    const AddQuestion = () => {
        console.log("AddQuestion start");
        const temp = {...newSurvey};
        temp.questionList.push({
            content: "",
            answerType: 0,
            skipFlag: false,
            displayMillis: 15000,
            choiceList: [{content: ""},{content: ""}]
       });
        ChangeNewSurvey(temp);

   };

    // 設問削除
    const DeleteQuestion = (index: number) => {
        console.log("DeleteQuestion start");
        const temp = {...newSurvey};
        temp.questionList.splice(index, 1);
        ChangeNewSurvey(temp);
   };

    // const [errorFlag, ChangeErrorFlag] = useState(false);
    const [isVisibleErrorMessage, ChangeErrorMessageVisiblity] = useState(false);
    const [errorMessage, ChangeErrorMessage] = useState("");
    const CloseErrorMessage = () => {
        ChangeErrorMessageVisiblity(false);
        ChangeErrorMessage("");
   };

    const ClickCancelButton = () => {
        console.log("ClickCancelButton start");
        CloseAddSurveyModal();
   };

    const ClickDoneButton = () => {
        console.log("ClickDoneButton start");
        let error = false;

        if(newSurvey.title === ""){
            ChangeErrorMessageVisiblity(true);
            ChangeErrorMessage("アンケート名を入力してください");
            error = true;
       }else if(isErrorInputSurveyName === true){
            ChangeErrorMessage("アンケート名は30字以内で入力してください");
            ChangeErrorMessageVisiblity(true);
            error = true;
       }else if(isErrorInputLimit.includes(true)){
            ChangeErrorMessage("アンケート表示時間を正しく入力してください");
            ChangeErrorMessageVisiblity(true);
            error = true;
       }else{
            const choiceNum: number[] = [];
            const nullCheck: string[] = [];
            const questionStringLengthCheck: number[] = [];
            const choiceStringLengthCheck: number[] = [];
            newSurvey.questionList.map((function(row, index) {
                choiceNum.push(0);
                nullCheck.push(row.content);
                questionStringLengthCheck.push(CountWord(row.content));
                row.choiceList.map((function(row) {
                    if(row.content !== ""){
                        choiceNum[index] = choiceNum[index] + 1;
                        choiceStringLengthCheck.push(CountWord(row.content));
                   }
                    return null;
               }));
                return null;
           }));
            if(nullCheck.includes("") === true){
                ChangeErrorMessage("設問を入力してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }else if(choiceNum.includes(0) === true || choiceNum.includes(1) === true){
                ChangeErrorMessage("選択肢は２つ以上用意してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }else if(questionStringLengthCheck.findIndex((question) => question > 50) !== -1){
                ChangeErrorMessage("設問は50字以内で入力してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }else if(choiceStringLengthCheck.findIndex((question) => question > 30) !== -1){
                ChangeErrorMessage("選択肢は30字以内で入力してください");
                ChangeErrorMessageVisiblity(true);
                error = true;
           }
       }

        if(error === false){
            dispatch(AddSurvey(newSurvey));
            setIsSaved(false);
            CloseAddSurveyModal();
       }

   };

    return (
        <>
            <div className={styles.editIcon} onClick={handlePropagation}>
                <AddCircleOutlineOutlinedIcon style={{cursor:"pointer", color: "var(--red)"}} fontSize="large" onClick={OpenAddSurveyModal}/>
            </div>

            <Modal
                open={isOpenAddSurveyModal}
                onClose={CloseAddSurveyModal}
            >
                <div className={styles.root}>
                    <div className={styles.title}>
                        <ul className={styles.surveyForm}>
                            <li>
                                <PuiTypography size={20} bold>新規アンケートを追加</PuiTypography>
                                <TextField color="secondary" id="description" onChange={InputSurveyName} multiline autoComplete="off" className={styles.inputForm}
                                    variant="outlined" placeholder="アンケート名を入力"  helperText={isErrorInputSurveyName && <span style={{color: "var(--red)"}}>全角30文字以内で正しく入力してください</span>}
                                />
                            </li>
                            <li>
                                <RadioGroup aria-label="displayFlag" name="displayFlag" defaultValue="1"  onChange={SelectDisplayFlag} style={{display:"block"}}>
                                    <FormControlLabel value="0" control={<RedRadio/>} label="一回のみ表示"/>
                                    <FormControlLabel value="1" control={<RedRadio/>} label="再表示する"/>
                                </RadioGroup>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.surveyList}>
                        {newSurvey.questionList.map((row, index)=>(
                            <ul key={index} className={styles.form}>
                                {(index > 0) &&
                                    <IconButton onClick={() => DeleteQuestion(index)} className={styles.deleteIcon}>
                                        <HighlightOffIcon style={{color:"var(--gray-85)"}}/>
                                    </IconButton>
                               }
                                <li>
                                    <PuiTypography bold>設問{index +1}</PuiTypography>
                                </li>
                                <li>
                                    <TextField color="secondary" id="description" onChange={(event) => InputQuestion(index, event)} multiline autoComplete="off" className={styles.inputForm}
                                        variant="outlined" placeholder="設問を入力"  helperText={CountWord(newSurvey.questionList[index].content) > 50 && <span style={{color: "var(--red)"}}>全角50文字以内で正しく入力してください</span>}
                                    />
                                </li>
                                <li>
                                    <RadioGroup aria-label="skipFlag" name="skipFlag" defaultValue={"true"} onChange={(event) => SelectSkipFlag(index, event)} style={{display:"block"}}>
                                        <FormControlLabel value="true" control={<RedRadio/>} label="スキップ可"/>
                                        <FormControlLabel value="false" control={<RedRadio/>} label="スキップ不可"/>
                                    </RadioGroup>
                                </li>
                                <li>
                                    <RadioGroup aria-label="answerFormat" name="answerFormat" defaultValue={"0"}  onChange={(event) => SelectAnswerFormat(index, event)} style={{display:"block"}}>
                                        <FormControlLabel value="0" control={<RedRadio/>} label="単一回答"/>
                                        <FormControlLabel value="1" control={<RedRadio/>} label="複数回答"/>
                                    </RadioGroup>
                                </li>
                                <li>
                                    {
                                        newSurvey.questionList[index].choiceList.map((content, num) =>(
                                            <TextField key={num} color="secondary" id="description" onChange={(event) => InputChoice(index, num, event)} multiline autoComplete="off" className={styles.inputForm}
                                                variant="outlined" placeholder={"選択肢" + (num +1)} style={{marginBottom: "5px"}} helperText={CountWord(newSurvey.questionList[index].choiceList[num].content) > 30 && <span style={{color: "var(--red)"}}>全角30文字以内で正しく入力してください</span>}
                                            />
                                        ))

                                   }
                                    {newSurvey.questionList[index].choiceList.length < 5 &&
                                        <IconButton className={styles.addIcon} onClick={() => AddChoice(index)}>
                                            <AddIcon style={{color:"var(--red)"}}/>
                                        </IconButton>
                                   }
                                </li>
                                <li>
                                    <PuiTypography>アンケート表示時間制限</PuiTypography>
                                    <RadioGroup aria-label="answerLimitTime" name="answerLimitTime" defaultValue={"15000"}  onChange={(event) => SelectAnswerLimit(index, Number(event.target.value))} style={{flexDirection: "row"}}>
                                        <FormControlLabel value="15000" control={<RedRadio/>} label="15秒"/>
                                        <FormControlLabel value="30000" control={<RedRadio/>} label="30秒"/>
                                        <FormControlLabel value="60000" control={<RedRadio/>} label="60秒"/>
                                        <FormControlLabel value="0" control={<RedRadio/>} label="無制限"/>
                                        <FormControlLabel value="1" control={<RedRadio/>} label="カスタム"/>
                                        {displayMillisCustomFlagList[index] &&
                                            <div style={{margin: "auto 0", position: "relative"}}>
                                                <sup style={{color:"var(--red)"}}>*</sup>
                                                <TextField style={{width: "65px"}} autoFocus required rows={1} rowsMax={600} type="number"
                                                    InputProps={{
                                                        endAdornment: <InputAdornment position="end">秒</InputAdornment>
                                                   }}
                                                    onChange={(event) => InputDisplayLimit(index, Number(event.target.value)* 1000)}
                                                    helperText={isErrorInputLimit[index] && <span style={{color: "var(--red)"}}>1〜600</span>}
                                                />
                                            </div>
                                       }
                                    </RadioGroup>
                                </li>
                            </ul>

                        ))}
                        {newSurvey.questionList.length < 5 &&
                            <IconButton onClick={AddQuestion} className={styles.addQuestionIcon} >
                                <AddCircleOutlineOutlinedIcon style={{color:"var(--red)"}}/>
                            </IconButton>
                       }
                    </div>
                    <div className={styles.bottomButton}>
                        <div className={styles.cancelButton}>
                            <PuiButton variant="outlined" onClick={ClickCancelButton}>キャンセル</PuiButton>
                        </div>
                        <div className={styles.doneButton}>
                            <PuiButton variant="outlined" onClick={ClickDoneButton}>追加</PuiButton>
                        </div>
                    </div>
                    <div>
                        <PuiMessage
                            open={isVisibleErrorMessage}
                            type="error"
                            title={errorMessage}
                            duration={5000}
                            onClose={CloseErrorMessage}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default AddSurveyModal;
